







































import Vue, { PropType } from 'vue'
import { IStudent } from '@/models/IStudent'
import { Actions } from '@/shared/Actions'

export default Vue.extend({
  name: 'StudentFilledForm',
  props: {
    student: {
      type: Object as PropType<IStudent>,
      default: (): IStudent => ({
        name: '',
        surname: '',
        addedBy: 'me'
      })
    },
    roomId: {
      type: String as PropType<string>,
      required: true
    }
  },
  computed: {
    isStudentDuplicated(): boolean {
      return this.$store.getters['duplicatedStudents'].find(
        (s: IStudent) =>
          s.surname.toLowerCase() === this.student.surname.toLowerCase() &&
          s.name.toLowerCase() === this.student.name.toLowerCase()
      )
    },
    isRemoveRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.ADMIN_STUDENT_REMOVE][
        this.roomId + (this.student as any)._id
      ]
    },
    isEmpty(): boolean {
      return !(this.student.name && this.student.surname)
    },
    inputMockClass(): string {
      return (
        (this.isEmpty ? 'empty-input' : 'fielled-input') +
        (this.isStudentDuplicated ? ' duplicate' : '')
      )
    }
  }
})
